import moment from 'moment'

export const REQUEST_STATUS = {
  pending: { label: 'Pendiente', color: 'warning' },
  visited: { label: 'Visita realizada', color: 'info' },
  quoted: { label: 'Cotizada', color: 'primary' },
  accepted: { label: 'Contratado', color: 'success' },
  completed: { label: 'Completado', color: 'secondary' },
  canceled: { label: 'Cancelada', color: 'danger' }
}

export const QUOTE_STATUS = {
  pending: { label: 'Esperando respuesta', color: 'warning' },
  accepted: { label: 'Aceptada', color: 'success' },
  rejected: { label: 'Rechazada', color: 'danger' },
  superseded: { label: 'Reemplazada', color: 'secondary' }
}

export const REQUEST_FILTERS = [
  { value: 'open', label: 'En curso' },
  { value: 'closed', label: 'Cerradas' },
  { value: '', label: 'Todas' }
]

export const formatDate = (date) => (date ? moment(date).format('DD/MM/YYYY') : '')

export const formatVisit = (date, time) => (date ? `${formatDate(date)}${time ? ` a las ${time}` : ''}` : '')

export const formatMessageTime = (date) => {
  const value = moment(date)
  return value.isSame(moment(), 'day') ? value.format('HH:mm') : value.format('DD/MM/YYYY HH:mm')
}

export const lastMessagePreview = (message) => {
  if (!message) return ''
  const previews = {
    request_created: 'Solicitud de visita enviada',
    visit_confirmed: 'Visita confirmada',
    visit_proposal: 'Propuesta de otra fecha para la visita',
    visit_done: 'Visita realizada',
    visit_canceled: 'Visita cancelada',
    quote: 'Nueva cotización',
    quote_accepted: 'Cotización aceptada',
    quote_rejected: 'Cotización rechazada',
    completed: 'Servicio completado',
    canceled: 'Solicitud cancelada'
  }
  return message.type === 'text' ? message.body : previews[message.type] || ''
}
